import './About.css';

export function About(): JSX.Element {
    return (
        <div className="About">
            <div className="about-container">
                <h1>About Me</h1>
                <p>
                    Hi! I'm Shahar Maoz, a passionate musician and developer with a love for both music and technology. 
                    With years of experience in the world of music and coding, I aim to bridge the gap between these two worlds 
                    by creating applications that make music creation more interactive and fun.
                </p>
                
                <p>
                    I have absolute pitch, which gives me a unique ability to understand and interact with music on a deep level.
                    Alongside this, I also have a background in software development, specializing in web technologies 
                    like React, TypeScript, and Node.js. Combining these passions, I strive to build tools that empower musicians 
                    and make music theory more accessible to developers and music enthusiasts alike.
                </p>
                
                <h1>About LoopyDoopy</h1>
                <p>
                    LoopyDoopy is an interactive web-based tool for musicians, allowing users to create and manipulate musical loops 
                    directly in their browser. The application enables users to record, visualize, and layer multiple loops in real-time,
                    all through an intuitive interface.
                </p>
                
                <p>
                    Built with modern web technologies like React and the Web Audio API, LoopyDoopy offers a smooth and responsive 
                    experience for both casual users and professionals. Whether you're looking to experiment with sounds or create 
                    intricate layers of music, LoopyDoopy is designed to make the process as seamless and creative as possible.
                </p>
                
                <p>
                    I created this project with the vision of providing musicians with an easy-to-use, portable tool that can be accessed 
                    from anywhere. Whether you’re a beginner or a seasoned musician, I hope this tool sparks creativity and helps you 
                    explore new musical possibilities.
                </p>
            </div>
        </div>
    );
}
